module.exports = __webpack_public_path__ + "img/report-sample-09@3x.ed049663.png";